import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full py-20 md:py-28 px-4 md:px-8 lg:px-16 overflow-hidden bg-[#FDF8F3]" data-id="element-53">
      <div className="max-w-3xl mx-auto text-center" data-id="element-54">
        {/* Badge */}
        <FadeIn delay={0.1} data-id="element-55">
          <span className="inline-block py-1 px-3 rounded-full bg-[#E8DED5] text-[#6B6560] text-sm font-medium tracking-wide mb-6" data-id="element-56">
            PARA MUJERES 30+
          </span>
        </FadeIn>

        {/* Headline */}
        <FadeIn delay={0.2} data-id="element-57">
          <h1 className="text-5xl md:text-6xl lg:text-7xl leading-[1.1] text-[#2D2A26] mb-8" data-id="element-58">
            No estás loca: <br data-id="element-59" />
            <span className="text-[#1A6B5A] italic" data-id="element-60">estás desregulada.</span>
          </h1>
        </FadeIn>

        {/* Opening lead */}
        <FadeIn delay={0.3} className="space-y-6 text-lg md:text-xl text-[#6B6560] leading-relaxed max-w-xl mx-auto text-left" data-id="element-61">
          <p data-id="element-62">
            Hay un cansancio que no es cansancio. Es vivir con una alarma
            prendida.
          </p>
          <p data-id="element-63">
            Te despertás (a veces 2–4am) con el corazón fuerte. O estás "bien" y
            de golpe sentís palpitaciones, irritabilidad, un nudo en el pecho… y
            la cabeza empieza:
          </p>
          <p className="italic text-[#2D2A26] border-l-2 border-[#C4785B] pl-4" data-id="element-64">
            "¿Qué me pasa? ¿Por qué ahora? ¿Y si me estoy volviendo loca?"
          </p>
          <p data-id="element-65">
            Y lo más cruel: por fuera seguís funcionando. Por dentro, estás
            sosteniéndote con uñas.
          </p>
        </FadeIn>
      </div>

      {/* Ebook Mockup — below the promise */}
      <div className="max-w-md mx-auto mt-16 md:mt-20" data-id="element-66">
        <FadeIn delay={0.5} className="relative" data-id="element-67">
          <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl" data-id="element-68">
            <img src="https://cdn.magicpatterns.com/uploads/kt4qyRLUeRG9wHB7aDuWSb/private_openrouter-generated-image-1770377597638.png" alt="Ansiedad Hormonal Ebook en iPad" className="w-full h-auto object-cover" data-id="element-69" />
          </div>

          {/* Decorative elements */}
          <div className="absolute -top-10 -right-10 w-64 h-64 bg-[#C4785B] opacity-10 rounded-full blur-3xl -z-10" data-id="element-70"></div>
          <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-[#1A6B5A] opacity-10 rounded-full blur-3xl -z-10" data-id="element-71"></div>
        </FadeIn>
      </div>

      {/* CTA — below mockup */}
      <div className="max-w-3xl mx-auto text-center" data-id="element-72">
        <FadeIn delay={0.6} className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-73">
          <Button size="lg" className="w-full sm:w-auto group" onClick={() => {
          const el = document.getElementById('pricing');
          if (el) el.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-74">
            Descargalo ahora — $269 UYU
            <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-75" />
          </Button>
          <p className="text-sm text-[#6B6560]" data-id="element-76">*PDF Instantáneo</p>
        </FadeIn>
      </div>
    </section>;
}